// ChangeMyPasswordDialog — modálne okno na zmenu vlastného hesla
// Použitie: <ChangeMyPasswordDialog open={open} onClose={...} />
// Backend: POST /api/auth/change-password (current_password + new_password)

import React, { useState } from 'react'
import { COLORS, RADIUS, TYPO, SPACE, SHADOW } from '../theme.js'
import { useToast } from '../components/Toast.jsx'
import { fetchAuth } from './fetchAuth.js'

export default function ChangeMyPasswordDialog({ open, onClose }) {
  const toast = useToast()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [show, setShow] = useState(false)
  const [busy, setBusy] = useState(false)

  if (!open) return null

  const reset = () => { setCurrent(''); setNext(''); setConfirm(''); setShow(false) }
  const close = () => { reset(); onClose() }

  const save = async () => {
    if (!current || !next) { toast.error('Vyplň súčasné aj nové heslo'); return }
    if (next.length < 6) { toast.error('Nové heslo musí mať aspoň 6 znakov'); return }
    if (next !== confirm) { toast.error('Nové heslo a kontrola sa nezhodujú'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ current_password: current, new_password: next }),
      })
      const d = await r.json()
      if (!r.ok) { toast.error(d.error || 'Zmena hesla zlyhala'); setBusy(false); return }
      toast.success('Heslo úspešne zmenené')
      setBusy(false)
      close()
    } catch (e) {
      toast.error('Chyba siete: ' + e.message); setBusy(false)
    }
  }

  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: `1px solid ${COLORS.line}`,
    borderRadius: RADIUS.md,
    fontSize: TYPO.sizes.base,
    fontFamily: 'inherit',
    marginTop: 4,
    boxSizing: 'border-box',
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: SPACE.md,
    }} onClick={close}>
      <div onClick={e => e.stopPropagation()} style={{
        width: 420, maxWidth: '100%',
        background: COLORS.bg,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.xl,
        padding: '28px 26px',
        boxShadow: SHADOW.lg,
        fontFamily: TYPO.family,
      }}>
        <h3 style={{ margin: 0, marginBottom: SPACE.md, fontSize: TYPO.sizes.lg }}>
          Zmeniť moje heslo
        </h3>

        <div style={{ marginBottom: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Súčasné heslo</div>
          <input type={show ? 'text' : 'password'} value={current} onChange={e => setCurrent(e.target.value)} style={inputStyle} autoFocus />
        </div>

        <div style={{ marginBottom: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nové heslo (najmenej 6 znakov)</div>
          <input type={show ? 'text' : 'password'} value={next} onChange={e => setNext(e.target.value)} style={inputStyle} />
        </div>

        <div style={{ marginBottom: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nové heslo znova</div>
          <input type={show ? 'text' : 'password'} value={confirm} onChange={e => setConfirm(e.target.value)} style={inputStyle} />
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: SPACE.lg, fontSize: TYPO.sizes.sm, color: COLORS.muted }}>
          <input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} /> zobraziť heslá
        </label>

        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <button onClick={close} disabled={busy} style={{
            padding: '9px 18px', border: `1px solid ${COLORS.line}`, background: '#fff',
            borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit',
          }}>Zrušiť</button>
          <button onClick={save} disabled={busy} style={{
            padding: '9px 18px', border: 'none', background: COLORS.add, color: '#fff',
            borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700,
          }}>{busy ? 'Ukladám…' : 'Uložiť heslo'}</button>
        </div>
      </div>
    </div>
  )
}
